import { render } from "./ReturnsEstimator.vue?vue&type=template&id=90668da6&scoped=true"
import script from "./ReturnsEstimator.vue?vue&type=script&lang=js"
export * from "./ReturnsEstimator.vue?vue&type=script&lang=js"

import "./ReturnsEstimator.vue?vue&type=style&index=0&id=90668da6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90668da6"]])

export default __exports__